jQuery(document).ready(function ($) {
  if ($('.template__page--quiz').length){
    var fingerprintLib = [];
    //build the library of all fingerprints with weights applied
    for (i=0;i<prodLib.length;i++){
      var print = [];
      var screening = [];
      
      for (j=0;j<prodLib[i].fingerprint.length;j++){
        var target = questionLib.find(x => x.title === prodLib[i].fingerprint[j].title);
        if (target){
          if (target.screening == 'true'){
            screening.push(prodLib[i].fingerprint[j].value * 1);
          }
          else{
            var weight = target.weight * 1;
            for (k=0;k<weight;k++){
              print.push(prodLib[i].fingerprint[j].value * 1);
            }
          }
        }
      }
      
      var prod = {
        "handle":prodLib[i].handle,
        "print":print,
        "screening":screening
      }
      console.log(prod);
      var printSum = prod.print.reduce((partialSum, a) => partialSum + a, 0)
      console.log(printSum);
      if ( printSum > 0){
        fingerprintLib.push(prod);
      }
      
    }

    //get array of users non-screening answers with weights applied
    function getAnswerArray(){
      var answerArray = [];
      $('.newQuestion').each(function(){
        var thisQuestion = $(this);
        
        thisQuestion.find('.newQuestion__checkBox').each(function(){
          var thisThing = $(this);
          if (!thisThing.hasClass('newQuestion__checkBox--screening')){
            var title = thisThing.attr('data-handle');
            console.log(title);
            var target = questionLib.find(x => x.title === title);
            var weight = target.weight * 1;
            if (thisThing.hasClass('newQuestion__checkBox--active')){
              var value = thisThing.attr('data-value');
              for (i=0;i<weight;i++){
                answerArray.push(value);
              }
            }
            else{
              for (i=0;i<weight;i++){
                answerArray.push(0);
              }
            }
          }
        });

        if (thisQuestion.find('.newQuestion__button--active').length > 0){
          var thisThing = thisQuestion.find('.newQuestion__button--active');
          if (!thisThing.hasClass('newQuestion__button--screening')){
            var title = thisThing.attr('data-handle');
            console.log(title);
            var target = questionLib.find(x => x.title === title);
            var weight = target.weight * 1;
            var value = thisThing.attr('data-value');
            for (i=0;i<weight;i++){
              answerArray.push(value);
            }
          }
        }
        else if (thisQuestion.find('.newQuestion__button').length > 0){
          var thisThing = thisQuestion.find('.newQuestion__button').first();
          if (!thisThing.hasClass('newQuestion__button--screening')){
            var title = thisThing.attr('data-handle');
            console.log(title);
            var target = questionLib.find(x => x.title === title);
            var weight = target.weight * 1;
            for (i=0;i<weight;i++){
              answerArray.push(0);
            }
          }
        }
        
      });
      
      return answerArray;
    }
    
    //get array of users screening answers
    function getScreenArray(){
      var answerArray = [];
      
      $('.newQuestion').each(function(){
        var thisQuestion = $(this);
        
        thisQuestion.find('.newQuestion__checkBox').each(function(){
          var thisThing = $(this);
          if (thisThing.hasClass('newQuestion__checkBox--screening')){
            var title = thisThing.attr('data-handle');
            var target = questionLib.find(x => x.title === title);
            var weight = target.weight * 1;
            if (thisThing.hasClass('newQuestion__checkBox--active')){
              var value = thisThing.attr('data-value');
              for (i=0;i<weight;i++){
                answerArray.push(value);
              }
            }
            else{
              for (i=0;i<weight;i++){
                answerArray.push(0);
              }
            }
          }
        });

        if (thisQuestion.find('.newQuestion__button--active').length > 0){
          var thisThing = thisQuestion.find('.newQuestion__button--active');
          if (thisThing.hasClass('newQuestion__button--screening')){
            var title = thisThing.attr('data-handle');
            var target = questionLib.find(x => x.title === title);
            var weight = target.weight * 1;
            var value = thisThing.attr('data-value');
            for (i=0;i<weight;i++){
              answerArray.push(value);
            }
          }
        }
        else{
          var thisThing = thisQuestion.find('.newQuestion__button').first();
          if (thisThing.hasClass('newQuestion__button--screening')){
            var title = thisThing.attr('data-handle');
            var target = questionLib.find(x => x.title === title);
            var weight = target.weight * 1;
            for (i=0;i<weight;i++){
              answerArray.push(0);
            }
          }
        }
        
      });
      return answerArray;
    }

    function getMeanObj(){
      var stDevArray = [];
      var meanArray = [];
      
      for (i=0;i<fingerprintLib.length;i++){
        console.log(fingerprintLib[i].print);
        console.log(i);
        stDevArray.push(math.std(fingerprintLib[i].print));
        meanArray.push(math.mean(fingerprintLib[i].print));
      }
      
      var meanObj = {
        stdDev: math.mean(stDevArray),
        mean: math.mean(meanArray)
      };
      
      return meanObj;
    }
    
    //normalize answers closer to the standard deviation of the fingerprints
    function getNormalizedAnswers(answers, meanObj){
      var normalizedArray = [];
        
      var meanStDev = meanObj.stdDev;
      var meanMean = meanObj.mean;
      var userStDev = math.std(answers);
      var newStDevArray = answers;
      var newStDev = userStDev;
        
      if (userStDev < meanStDev){
        while(newStDev < meanStDev){
          newStDevArray = newStDevArray.map(x => x * 1.1);
          newStDev = math.std(newStDevArray);
        }
      }
      else if (userStDev > meanStDev){
        while(newStDev > meanStDev){
          newStDevArray = newStDevArray.map(x => x * 0.9);
          newStDev = math.std(newStDevArray);
        }
      }
      return newStDevArray;
    }

    //check user answer set against product fingerprint, return a match rating
    function getMatchPercetange(userAnswers, userScreens, prodAnswers, prodScreens){
      var normalizedUserAnswers = JSON.parse(JSON.stringify(userAnswers));
      var matchArray = [];
      for(i=0;i<normalizedUserAnswers.length;i++){
        var match = Math.abs(((Math.abs(prodAnswers[i] - normalizedUserAnswers[i]) * (1/6)) * 100) - 100);
        matchArray.push(match);
      }
      var answerMatchAverage = math.mean(matchArray);
      for(i=0;i<userScreens.length;i++){
        if(userScreens[i] == 1){
          answerMatchAverage *= (userScreens[i]*prodScreens[i]);
        }
      }
      return answerMatchAverage;
    }

    //get the array of products sorted by closest match of answers
    function getOrderedProductHandles(userAnswers, userScreens){
      var meanObj = getMeanObj();
      
      var normalizedUserAnswers = getNormalizedAnswers(userAnswers, meanObj);
      
      var unorderedArray = [];
      var lockedFingerprintLib = JSON.parse(JSON.stringify(fingerprintLib));
      console.log(lockedFingerprintLib);
      console.log(lockedFingerprintLib.length);
      for (i=0;i<lockedFingerprintLib.length;i++){
        console.log(i);
        var iterationObj = lockedFingerprintLib[i];

        var normalizedUserAnswers = JSON.parse(JSON.stringify(normalizedUserAnswers));
        var matchArray = [];
        for(j=0;j<normalizedUserAnswers.length;j++){
          var match = Math.abs(((Math.abs(iterationObj.print[j] - normalizedUserAnswers[j]) * (1/6)) * 100) - 100);
          matchArray.push(match);
        }
        var answerMatchAverage = math.mean(matchArray);
        for(j=0;j<userScreens.length;j++){
          if(userScreens[j] == 1){
            answerMatchAverage *= (userScreens[j] * iterationObj.screening[j]);
          }
        }
        
        var obj = {
          "handle": iterationObj["handle"],
          "match": answerMatchAverage
        };
        console.log(obj);
        unorderedArray.push(obj);
      }
      console.log(unorderedArray);
      var sortedArray = JSON.parse(JSON.stringify(unorderedArray)).sort((a, b) => b.match - a.match);
      
      //var sortedArray = '';
      return sortedArray;
    }

    function getTopArrayItems(sortedArray, numberOfProds){
      var topItems = [];
      for (var i = 0;i<numberOfProds;i++){
        if (sortedArray[i].match > 0){
          topItems.push(JSON.parse(JSON.stringify(sortedArray[i])));
        }
      }
      return topItems;
    }
  
    $('.newQuestion__buttonButton').on('click', function(){
      var userAnswers = getAnswerArray();
      var userScreens = getScreenArray();

      var sortedArray = getOrderedProductHandles(userAnswers, userScreens);
      var topItems = getTopArrayItems(sortedArray, 6);
      console.log(topItems);
      var prodUrlString = '';
      for (var i=0;i<topItems.length;i++){
        if (i > 0){
          prodUrlString += '--';
        }
        prodUrlString += topItems[i].handle;
      }
      console.log(prodUrlString);
      window.location.href = '/pages/quiz-results?prods=' + prodUrlString;
    });
  
    console.log(prodLib);
    console.log(questionLib);
    console.log(fingerprintLib);

    var slideCount = $('.newQuestion').length;
    $('.newQuiz__track').attr('style', 'width:calc(100vw * '+slideCount+');');
    $('.newQuestion').first().addClass('newQuestion--active');

    var slideState = "ready";
    
    function nextSlide(currentSlide, slideCount){
      slideState = "moving";
      // console.log('slide', slideCount);
      var nextIndex = (currentSlide.attr('data-slide') * 1) + 1;
      console.log('slide', nextIndex);
      if (nextIndex < $('.newQuestion--end').attr('data-slide') * 1 + 1){
        $('.newQuiz__track').attr('style', 'width:calc(100vw * '+slideCount+');left:-'+nextIndex+'00%;');
        $('.newQuestion').removeClass('newQuestion--active');
        $('.newQuestion[data-slide="'+nextIndex+'"]').addClass('newQuestion--active');
      
        if (nextIndex == $('.newQuestion--end').attr('data-slide') * 1 || nextIndex == $('.newQuestion--gateway').attr('data-slide') * 1){
          $('.newQuizHeader__skipButton').attr('style', 'opacity:0.2;');
        }
        else{
          $('.newQuizHeader__skipButton').attr('style', 'opacity:1;');
        }
      }
      setTimeout(function(){
        slideState = "ready";
      }, 100);
    }
    function prevSlide(currentSlide, slideCount){
      slideState = "moving";
      var nextIndex = (currentSlide.attr('data-slide') * 1) - 1;
      $('.newQuiz__track').attr('style', 'width:calc(100vw * '+slideCount+');left:-'+nextIndex+'00%;');
      $('.newQuestion').removeClass('newQuestion--active');
      $('.newQuestion[data-slide="'+nextIndex+'"]').addClass('newQuestion--active');
      $('.newQuizHeader__skipWrapper').show();
      if (nextIndex === 0){
        $('.newQuizHeader__nav').fadeOut();
      }
      if (nextIndex == $('.newQuestion--end').attr('data-slide') * 1 || nextIndex == $('.newQuestion--gateway').attr('data-slide') * 1){
        $('.newQuizHeader__skipButton').attr('style', 'opacity:0.2;');
      }
      else{
        $('.newQuizHeader__skipButton').attr('style', 'opacity:1;');
      }
      setTimeout(function(){
        slideState = "ready";
      }, 100);
    }
    
    $('.newQuestion__startButton').on('click', function(){
      nextSlide($(this).closest('.newQuestion'), slideCount);
      $('.newQuizHeader__nav').fadeIn();
    });

    $('.newQuestion__sectionContinue').on('click', function(){
      nextSlide($(this).closest('.newQuestion'), slideCount);
    });

    $('.newQuestion__gatewayButton--no').on('click', function(){
      $('.newQuestion__gatePop').fadeIn();
    });

    $('.newQuestion__gatewayButton--yes').on('click', function(){
      nextSlide($(this).closest('.newQuestion'), slideCount);
    });

    $('.newQuestion__checkBox').on('click', function(){
      if($(this).hasClass('newQuestion__checkBox--active')){
        $(this).removeClass('newQuestion__checkBox--active');
      }
      else{
        $(this).addClass('newQuestion__checkBox--active');
      }
    });

    $('.newQuestionCheckBoxContinue, .newQuestion__checkBox--none').on('click', function(){
      nextSlide($(this).closest('.newQuestion'), slideCount);
    });

    $('.newQuestion__whyButton').on('click', function(){
      $(this).closest('.newQuestion').find('.newQuestion__whyPopup').fadeIn();
    });

    $('.newQuestion__whyPopupClose, .newQuestion__whyPopupBkg, .newQuestion__whyPopupOk').on('click', function(){
      $(this).closest('.newQuestion').find('.newQuestion__whyPopup').fadeOut();
    });

    $('.newQuestion__button').on('click', function(){
      if($(this).hasClass('newQuestion__button--active')){
        nextSlide($(this).closest('.newQuestion'), slideCount);
      }
      else{
        
        $(this).closest('.newQuestion').find('.newQuestion__button').removeClass('newQuestion__button--active');
        nextSlide($(this).closest('.newQuestion'), slideCount);
        $(this).addClass('newQuestion__button--active');
      }
    });

    $('.newQuizHeader__backButton').on('click', function(){
      if (slideState == "ready"){
        prevSlide($('.newQuestion--active'), slideCount);
      }
    });

    $('.newQuizHeader__skipButton').on('click', function(){
      if (slideState == "ready"){
        nextSlide($('.newQuestion--active'), slideCount);
      }
    });

    $('.newQuizHeader__exitButton').on('click', function(){
      window.location.href = '/';
    });
    
  }

  if ($('.template__page--quizResults').length){
    var getUrlParameter = function getUrlParameter() {
      var fullUrl = window.location.href;
      var fullQuery = fullUrl.split('?');
      var eachQuery = fullQuery[1].split('&');
      var prods = eachQuery[0].replace('prods=', '');
      return prods;
    };

    var prodsString = getUrlParameter();
    console.log(prodsString);
    var selectedHandles = prodsString.split('--');
    console.log(selectedHandles);
    var selectedProds = [];
    for (var i=0;i<selectedHandles.length;i++){
      selectedProds.push({});
    }
    for (var i=0;i<prodLib.length;i++){
      if (selectedHandles.indexOf(prodLib[i].handle) > -1){
        selectedProds[selectedHandles.indexOf(prodLib[i].handle)] = prodLib[i];
      }
    }
    console.log(selectedProds);

    var slideTemplate = $('.newQResSlider__slider').html();
    $('.newQResSlide--template').remove();
    for (var i=0;i<selectedProds.length;i++){
      if (selectedProds[i].available){
        $('.newQResSlider__slider').append(slideTemplate);
        var newSlide = $('.newQResSlide--template').last();
        newSlide.find('.newQResSlide__image').attr('src', selectedProds[i].image);
        newSlide.find('.newQResSlide__inner').attr('data-handle', selectedProds[i].handle);
        newSlide.find('.newQResSlide__inner').attr('data-id', selectedProds[i].variants[0].id);
        newSlide.find('.newQResSlide__title').html(selectedProds[i].title);
        newSlide.find('.newQResSlide__text').text(selectedProds[i].shortText);
        newSlide.removeClass('newQResSlide--template');
      }
    };

    $('.newQResSlider__slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots:true,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: false,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

    var mailToBody = 'mailto:?subject=Traditional Medicinals - There`s a Tea For That Quiz Results&body=View your results here ' + window.location.href;
    $('.newQResBanner__emailLink').attr('href', mailToBody);

    var thumbTemplate = $('.quizResPopup__thumbFlex').html();
    $('.quizResPopup__thumb--template').remove();
    
    function fillPopup(clickedProd){
      $('.quizResPopup__image').attr('src', clickedProd.image);
      $('.quizResPopup__thumbFlex').html('');
      for (var j=0;j<clickedProd.otherImages.length;j++){
        $('.quizResPopup__thumbFlex').append(thumbTemplate);
        var newThumb = $('.quizResPopup__thumb').last();
        newThumb.attr('data-image', clickedProd.otherImages[j]);
        newThumb.find('img').attr('src', clickedProd.otherImages[j]);
      }
      $('.quizResPopup__thumb').first().addClass('quizResPopup__thumb--active');
      bindThumbs();
      
      $('.quizResPopup__title').html(clickedProd.title);
      $('.quizResPopup__recommendation').text(clickedProd.recomendationText);
      $('.quizResPopup__recommendation').text(clickedProd.recomendationText);
      $('.quizResPopup__variant').text(clickedProd.variants[0].title);
      $('.quizResPopup__price').text(clickedProd.variants[0].price);
      $('.quizResPopup__buy').attr('data-id', clickedProd.variants[0].id);

      if (clickedProd.firstSection != ''){
        $('.quizResPopup__listItem--one').show();
        $('.quizResPopup__listItem--one .quizResPopup__listItemImage').attr('src', clickedProd.firstIcon);
        $('.quizResPopup__listItem--one .quizResPopup__listItemTitle').text(clickedProd.firstSection);
        $('.quizResPopup__listItem--one .quizResPopup__listItemText').text(clickedProd.firstBenefit);
      }
      else{
        $('.quizResPopup__listItem--one').hide();
      }

      if (clickedProd.secondSection != ''){
        $('.quizResPopup__listItem--two').show();
        $('.quizResPopup__listItem--two .quizResPopup__listItemImage').attr('src', clickedProd.secondIcon);
        $('.quizResPopup__listItem--two .quizResPopup__listItemTitle').text(clickedProd.secondSection);
        $('.quizResPopup__listItem--two .quizResPopup__listItemText').text(clickedProd.secondBenefit);
      }
      else{
        $('.quizResPopup__listItem--two').hide();
      }

      if (clickedProd.thirdSection != ''){
        $('.quizResPopup__listItem--three').show();
        $('.quizResPopup__listItem--three .quizResPopup__listItemImage').attr('src', clickedProd.thirdIcon);
        $('.quizResPopup__listItem--three .quizResPopup__listItemTitle').text(clickedProd.thirdSection);
        $('.quizResPopup__listItem--three .quizResPopup__listItemText').text(clickedProd.thirdBenefit);
      }
      else{
        $('.quizResPopup__listItem--three').hide();
      }

      if (clickedProd.fourthSection != ''){
        $('.quizResPopup__listItem--four').show();
        $('.quizResPopup__listItem--four .quizResPopup__listItemImage').attr('src', clickedProd.fourthIcon);
        $('.quizResPopup__listItem--four .quizResPopup__listItemTitle').text(clickedProd.fourthSection);
        $('.quizResPopup__listItem--four .quizResPopup__listItemText').text(clickedProd.fourthBenefit);
      }
      else{
        $('.quizResPopup__listItem--four').hide();
      }

      if (clickedProd.description !== "") {
        $('.quizResPopup__description').html(clickedProd.description);
        $('.quizResPopup__description').show();
      } else {
        $('.quizResPopup__description').hide();
      }

      var pdpInfoHtml = '';
      if (clickedProd.herbalPower !== "" || clickedProd.taste !== "" || clickedProd.personality !== "" || clickedProd.caffeineLevels !== "") {
        pdpInfoHtml = '<div class="pdp__notes pdp__notes--desktop"><div class="inner">';

        if (clickedProd.herbalPower !== "") {
          pdpInfoHtml += `<div class="note d-flex  justify-between">
                <div class="note__icon">
                  <img src="${clickedProd.herbalPowerIcon}" alt="" />
                </div>
                <div class="note__info">
                  <span class="eyebrow eyebrow--bold">Herbal Power</span>
                  <p>${clickedProd.herbalPower}</p>
                </div>
              </div>`;
        }

        if (clickedProd.taste !== "") {
          pdpInfoHtml += `<div class="note d-flex  justify-between">
                <div class="note__icon">
                  <img src="${clickedProd.tasteIcon}" alt="" />
                </div>
                <div class="note__info">
                  <span class="eyebrow eyebrow--bold">Taste</span>
                  <p>${clickedProd.taste}</p>
                </div>
              </div>`;
        }

        if (clickedProd.personality !== "") {
          pdpInfoHtml += `<div class="note d-flex  justify-between">
                <div class="note__icon">
                  <img src="${clickedProd.personalityIcon}" alt="" />
                </div>
                <div class="note__info">
                  <span class="eyebrow eyebrow--bold">Personality</span>
                  <p>${clickedProd.personality}</p>
                </div>
              </div>`;
        }

        if (clickedProd.caffeineLevels !== "") {
          pdpInfoHtml += `<div class="note d-flex  justify-between">
                <div class="note__icon">
                  <img src="${clickedProd.caffeineLevelsIcon}" alt="" />
                </div>
                <div class="note__info">
                  <span class="eyebrow eyebrow--bold">Caffeine Levels</span>
                  <p>${clickedProd.caffeineLevels}</p>
                </div>
              </div>`;
        }
        
        pdpInfoHtml += '</div>';
        pdpInfoHtml += '</div>';
      }

      $('.quizResPopup__pdp-info').html(pdpInfoHtml);
    }
    
    $('.newQResSlide__inner').on('click', function(){
      var thisHandle = $(this).attr('data-handle');
      var clickedProd = null;
      for (var i=0;i<selectedProds.length;i++){
        if (selectedProds[i].handle == thisHandle){
          clickedProd = selectedProds[i];
        }
      }
      if (clickedProd != null){
        fillPopup(clickedProd);
        $('.quizResPopup').fadeIn();
      }
      
    });

    $('.quizResPopup__close, .quizResPopup__background').on('click', function(){
      $('.quizResPopup').fadeOut();
    });

    function bindThumbs(){
      $('.quizResPopup__thumb').on('click', function(){
        var thisImg = $(this).attr('data-image');
        $('.quizResPopup__image').attr('src', thisImg);
        $('.quizResPopup__thumb--active').removeClass('quizResPopup__thumb--active');
        $(this).addClass('quizResPopup__thumb--active');
      });
    }

    $('.quizResPopup__buy').on('click', function(){
      var thisId = $(this).attr('data-id') * 1;
      CartJS.addItem(thisId, 1, {}, {
        "success": function(data, textStatus, jqXHR) {
          window.open('/cart', '_blank').focus();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          alert('Error: ' + errorThrown + '!');
        }
      });
    });

    $('.newQuizAddAll').on('click', function(){
      var theseProds = [];
      $('.newQResSlide__inner').each(function(){
        var iterationId = $(this).attr('data-id') * 1;
        var thisProd = {
          id: iterationId,
          quantity: 1
        }
        theseProds.push(thisProd);
      });

      CartJS.addItems(theseProds, {
        "success": function(data, textStatus, jqXHR) {
          window.open('/cart', '_blank').focus();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          alert('Error: ' + errorThrown + '!');
        }
      });
    });
    
  }
});